@if (load()) {
  <div class="fixed inset-0 z-1000">
    <div class="bg-black/30 h-full flex justify-center items-center">
      <div class="loader5"></div>
    </div>
  </div>
}
